import { render, staticRenderFns } from "./DownloadTeacher.vue?vue&type=template&id=c58bb372&scoped=true&"
import script from "./DownloadTeacher.vue?vue&type=script&lang=js&"
export * from "./DownloadTeacher.vue?vue&type=script&lang=js&"
import style0 from "./DownloadTeacher.vue?vue&type=style&index=0&id=c58bb372&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58bb372",
  null
  
)

export default component.exports